import { Injectable } from '@angular/core';

@Injectable()
export class OrderEntryConfirmService {
  private _agreeCharges:boolean;
  private _agreeTC:boolean;
  private _approvalReason:boolean;

  public get agreeCharges():boolean {
    return this._agreeCharges;
  }

  public set agreeCharges(agreeCharges:boolean) {
    this._agreeCharges = agreeCharges;
  }

  public get agreeTC():boolean {
    return this._agreeTC;
  }

  public set agreeTC(agreeTC:boolean) {
    this._agreeTC = agreeTC;
  }

  public get approvalReason():boolean {
    return this._approvalReason;
  }

  public set approvalReason(approvalReason:boolean) {
    this._approvalReason = approvalReason;
  }

  public clear():void {
    this.agreeCharges = undefined;
    this.agreeTC = undefined;
    this.approvalReason = undefined;
  }
}